import React from 'react'
import { Link } from 'react-router-dom'
import { assets } from '../assets/assets'

const ReferDonate = () => {
  return (
    <div>
       <div className="breadcrumb_sec">
        <div className="container">
            <nav>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='/my-account'>My Account</Link>
                    </li>
                    <li className="breadcrumb-item">
                        Refer & Donate
                    </li>
                </ol>
            </nav>
            <div className="support pb-3">
                <h3>Refer – Spread the Word</h3>
                <p>Share and Amplify Impact Through Referring to a friend</p>
            </div>
        </div>
    </div>

    <div className="refer_donate_section pt-5 pb-5 mb-5">
        <div className="container">
            <div className="row gx-2 gy-4 gy-md-0">
                <div className="col-6 col-lg-3 col-xl-2">
                    <div className="donate_card card h-100 border-0 text-center p-1  p-md-3">
                        <div className="icon">
                            <img src={assets.bookmark_icon} alt="Donated Amounot"/>
                        </div>
                        <div className="price">₹ 0</div>
                        <div className="name mt-auto">Donated Amount</div>
                    </div>
                </div>
                <div className="col-6 col-lg-3 col-xl-2">
                    <div className="donate_card card h-100 border-0 text-center p-1  p-md-3">
                        <div className="icon">
                            <img src={assets.calender_icon} alt="Active Subscription"/>
                        </div>
                        <div className="price">0</div>
                        <div className="name mt-auto">Active Subscription</div>
                    </div>
                </div>
            </div>

            <div className="mt-5 mb-5">
                <h3 className="mb-5 text-center">How It Works</h3>
                <div className="row g-2 d-flex align-items-center justify-content-center">
                    <div className="col-lg-7 col-xl-5">
                        <div className="item-box d-flex justify-content-center">
                            <div className="col-4">
                                <div className="card h-100 border-0 text-center">
                                    <div className="number bg-warning rounded-pill d-inline p-2 mx-auto">01</div>
                                    <div className="work-name mt-3">Search for a cause</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="card h-100 border-0 text-center">
                                    <div className="number bg-warning rounded-pill d-inline p-2 mx-auto">02</div>
                                    <div className="work-name mt-3">Copy the link</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="card h-100 border-0 text-center">
                                    <div className="number bg-warning rounded-pill d-inline p-2 mx-auto">03</div>
                                    <div className="work-name mt-3">Refer to a friend</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="recent_search">
                <h5 className="search_text mb-4">RECENT SEARCH</h5>
                <div className="row gy-4 gy-lg-0 d-flex justify-content-between">
                    <div className="col-lg-6 ">
                        <div className="refer_box overflow-hidden">
                            <p className="refer_text mb-3">
                                Celebrate your Birthday with the kids and
                                make your celebration more joyous
                            </p>
                            <div className="d-md-flex align-items-center">
                                <div className="mb-3 mb-md-0 me-0 me-md-3">
                                    <img src={assets.product_box_img} className="img-fluid rounded" alt='product-img'/>
                                </div>
                                <div className="w-100">
                                    <div className="d-flex align-items-center link_txt justify-content-between">
                                        <div className="me-3">
                                            <p>https://www.charitism.com/campaign/BVP?referrer=66e2a</p>
                                        </div>
                                        <div>
                                            <button type="button" className="border-0 bg-transparent">
                                                <img className="img-fluid copy-icon" src="assets/images/icons/copy.png"
                                                    alt="Copy Button"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="refer_box overflow-hidden">
                            <p className="refer_text mb-3">
                                Celebrate your Birthday with the kids and make your celebration more joyous
                            </p>
                            <div className="d-md-flex align-items-center">
                                <div className="mb-3 mb-md-0 me-0 me-md-3">
                                    <img src={assets.product_box_img} className="img-fluid rounded" alt='-product-image'/>
                                </div>
                                <div className="w-100">
                                    <div className="d-flex align-items-center link_txt justify-content-between">
                                        <div className="me-3">
                                            <p>https://www.charitism.com/campaign/BVP?referrer=66e2a</p>
                                        </div>
                                        <div>
                                            <button type="button" className="border-0 bg-transparent">
                                                <img className="img-fluid copy-icon" src="assets/images/icons/copy.png"
                                                    alt="Copy Button"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    </div>
  )
}

export default ReferDonate
